var _path, _path2, _g, _text, _text2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKhcLogo = function SvgKhcLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 410,
    height: 150
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#136538",
    d: "M0 0h410v150H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4,
    d: "M6 6h398v140H6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 6h12v140H5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 75 80 5h5L35 75zM10 75l70 70h5L35 75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 6h8v140h-8z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 65,
    fill: "#fff",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 60,
    fontWeight: "bold"
  }, "\r\n    Keith\u2019s\r\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 125,
    fill: "#fff",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 60,
    fontWeight: "bold"
  }, "\r\n    Haircenter\r\n  ")));
};
export { SvgKhcLogo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDEwIiBoZWlnaHQ9IjE1MCIgdmlld0JveD0iMCAwIDQxMCAxNTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQogIDwhLS0gQmFja2dyb3VuZCAtLT4NCiAgPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjQxMCIgaGVpZ2h0PSIxNTAiIGZpbGw9IiMxMzY1MzgiLz4NCg0KICA8IS0tIEJvcmRlciAtLT4NCiAgPHJlY3QgeD0iNiIgeT0iNiIgd2lkdGg9IjM5OCIgaGVpZ2h0PSIxNDAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iNCIvPg0KDQogIDwhLS0gTGVmdCAiSyIgc2hhcGUgLS0+DQogIDxnIGZpbGw9IndoaXRlIj4NCiAgICA8IS0tIFZlcnRpY2FsIGJhciAtLT4NCiAgICA8cmVjdCB4PSI1IiB5PSI2IiB3aWR0aD0iMTIiIGhlaWdodD0iMTQwIi8+DQogICAgDQogICAgPCEtLSBUb3AgZGlhZ29uYWwgLS0+DQogICAgPHBvbHlnb24gcG9pbnRzPSIxMCw3NSA4MCw1IDg1LDUgMzUsNzUiLz4NCiAgICANCiAgICA8IS0tIEJvdHRvbSBkaWFnb25hbCAtLT4NCiAgICAgPHBvbHlnb24gcG9pbnRzPSIxMCw3NSA4MCwxNDUgODUsMTQ1IDM1LDc1Ii8+DQoNCiAgICA8IS0tIFZlcnRpY2FsIGJhciAyIC0tPg0KICAgIDxyZWN0IHg9IjgwIiB5PSI2IiB3aWR0aD0iOCIgaGVpZ2h0PSIxNDAiLz4NCiAgPC9nPg0KDQogIDwhLS0gVGV4dCAtLT4NCiAgPHRleHQgeD0iMTAwIiB5PSI2NSIgZm9udC1mYW1pbHk9IkFyaWFsLCBIZWx2ZXRpY2EsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iNjAiIGZpbGw9IndoaXRlIiBmb250LXdlaWdodD0iYm9sZCI+DQogICAgS2VpdGjigJlzDQogIDwvdGV4dD4NCiAgPHRleHQgeD0iMTAwIiB5PSIxMjUiIGZvbnQtZmFtaWx5PSJBcmlhbCwgSGVsdmV0aWNhLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjYwIiBmaWxsPSJ3aGl0ZSIgZm9udC13ZWlnaHQ9ImJvbGQiPg0KICAgIEhhaXJjZW50ZXINCiAgPC90ZXh0Pg0KPC9zdmc+";